import {clientGetWrapper, clientPostWrapper} from "../api/Api";
import {
    GET_ALL_CUSTOM_EDITOR_PAGES,
    GET_CUSTOM_EDITOR_PAGE_BY_LINK,
    GET_CUSTOM_EDITOR_ICON_LIBRARY,
    INSERT_CUSTOM_EDITOR_PAGE,
    UPDATE_CUSTOM_EDITOR_PAGE,
    UPLOAD_CUSTOM_EDITOR_IMAGE
} from "../common/constants/routes";

export const getCustomPages = () => {
    return clientGetWrapper(GET_ALL_CUSTOM_EDITOR_PAGES);
}

export const updateCustomPage  = (page) => {
    return clientPostWrapper(UPDATE_CUSTOM_EDITOR_PAGE, page);
}

export const getCustomPageDataByLink = (link) => {
    return clientPostWrapper(GET_CUSTOM_EDITOR_PAGE_BY_LINK, {link});
}

export const insertNewPageType = (page) => {
    return clientPostWrapper(INSERT_CUSTOM_EDITOR_PAGE, page);
}

export const uploadCustomPageImage = (formData) => {
    return clientPostWrapper(UPLOAD_CUSTOM_EDITOR_IMAGE, formData, true);
}

export const getCustomEditorIconLibrary = () => {
    return clientGetWrapper(GET_CUSTOM_EDITOR_ICON_LIBRARY);
}
